<template>
    <StartModalInternal v-model="startModalState" @validated="(data) => startModalEvent(data)"
        @closed="closeModal('StartModalInternal')" :group-name="groupName"/>
    <LoginModal v-model="loginModalState" :form-data-prop="formData" @closed="closeModal('LoginModal')" />
    <RegisterModal v-model="registerModalState" :form-data-prop="formData" @closed="closeModal('RegisterModal')" />
</template>

<script>
import LoginModal from './CheckoutProcess/LoginModal';
import RegisterModal from './CheckoutProcess/RegisterModal';
import StartModalInternal from './CheckoutProcess/StartModalInternal';

export default {
    expose: ['showModal'],
    components: {
        LoginModal,
        RegisterModal,
        StartModalInternal,
    },
    props: {
        groupName: String,
    },
    data() {
        return {
            activeModal: false,
            formData: {},
        };
    },
    methods: {
        startModalEvent(data) {
            this.formData = { ...this.formData, ...data.formData, };
            this.showModal(data.nextModal);
        },
        showModal(modal) {
            this.activeModal = modal;
        },
        closeModal(modal) {
            if (this.activeModal == modal) {
                this.activeModal = false;
            }
        },
    },
    computed: {
        startModalState() {
            return this.activeModal == 'StartModalInternal';
        },
        loginModalState() {
            return this.activeModal == 'LoginModal';
        },
        registerModalState() {
            return this.activeModal == 'RegisterModal';
        },
    },
}
</script>
